import { Navigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext.jsx';

/**
 * Route guard that enforces Enneagram completion for downstream features.
 *
 * Grandfathering rule: existing users who already have a study but no
 * enneagram_type on their profile pass through unblocked. This applies to
 * users who signed up before the Enneagram was made required. New users
 * (no study yet) hit the gate and are redirected to /enneagram.
 */
export default function EnneagramRequired({ children }) {
  const { userProfile, study, isSyncing } = useApp();

  // Hold the redirect decision while the first cloud sync is in flight.
  // Without this gate, returning users on a fresh device fall through
  // to the redirect before profile.enneagram_type is restored.
  if (isSyncing) return null;

  // Grandfather: existing users with a study but no Enneagram pass through.
  if (study && !userProfile?.enneagram_type) {
    return children;
  }

  // New users without Enneagram: redirect to /enneagram.
  if (!userProfile?.enneagram_type) {
    return <Navigate to="/enneagram" replace />;
  }

  return children;
}
